// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "26.45.607",
  "buildId": "20261105T142045516Z",
  "builtAt": "2026-11-05T14:20:45.516Z"
} as const;
